import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthProvider';
import PrivateRoute from './PrivateRoutes';
import Home from './components/Home';
import {Login} from './components/Login';
import Dashboard from './components/Dashboard';
import React from 'react';
import './App.css';
import Header from './components/HeaderNav';
import { Member } from './components/member';

function App() {
  return (
    <div className='mainAppDiv'>
      <Router>
        <Header />
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />            
              <Route path="/" element={<Home />} />              
              <Route path="/Member/:email" element={<Member/>} />
            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
